export default __webpack_public_path__ + "static/media/Navigation_Design_-_adamr.space___Codecademy.f5e60a84.pdf";